<template>
  <Head>
    <title>{{ entry.seo.title }}</title>
    <meta property="description" :content="entry.seo.description" />
  </Head>

  <Layout :alerts="entry.alerts">
    <PageIntro :data="entry.pageMasthead"></PageIntro>

    <EventsGrid :events="entry.events"></EventsGrid>

    <Hr />
    <CardGrid :data="data"> </CardGrid>

    <Hr />

    <Cta :data="entry.pageComponents.ctaBanner[0]"> </Cta>

    <Hr />
    <CardGrid :data="entry.pageComponents.ctaCardGroup[0]" />
  </Layout>
</template>

<script>
import Heading from "../../Components/Atoms/Heading.vue";
import Hr from "../../Components/Atoms/Hr.vue";
import EventsGrid from "../../Components/Page-Components/EventsGrid.vue";
import CardGrid from "../../Components/Page-Components/CardGrid.vue";
import Cta from "../../Components/Page-Components/Cta.vue";

export default {
  components: {
    Cta,
    EventsGrid,
    Heading,
    Hr,
    CardGrid,
  },

  props: {
    siteUrl: String,
    entry: Object,
  },

  setup(props) {
    console.log(props.entry);

    let cards = [];
    for (let i = 0; i < props.entry.webinars.items.length; i++) {
      cards.push({
        ...props.entry.webinars.items[i],
        ...{ cardLayout: "WebinarVideoCard" },
      });
    }

    const data = {
      title: "Watch webinars on demand",
      numberOfColumns: "3",
      backgroundColor: "white",
      cards: cards,
    };

    return {
      data,
    };
  },
};
</script>
